import { createListenerMiddleware } from "@reduxjs/toolkit";
import { uploadContent } from "../listIcon/actions";
import { clearMessage, clearError } from "../listIcon/slice";
import { toast } from "react-toastify";

export const uploadContentListener = createListenerMiddleware();

uploadContentListener.startListening({
  actionCreator: uploadContent.fulfilled,
  effect: async (action, listenerApi) => {

    const message = action.payload?.message || "Content uploaded successfully";
    toast.success(message);
    // clear state globally
    listenerApi.dispatch(clearMessage());
  },
});

uploadContentListener.startListening({
  actionCreator: uploadContent.rejected,
  effect: async (action, listenerApi) => {
    const message = action.payload?.message ||  "Upload failed";
    toast.error(message);
    // clear state globally
    listenerApi.dispatch(clearError());
  },
});
